export default { // 该需求运行在浏览器，入口短信短连接进入
  tabs: [
    {
      name: 'feedback',
      path: '/feedback',
      component: () => import('./src/inputFeedback'),
      meta: {
        title: '情况反馈',
        openNetwork: true // 公开网络可访问
      }
    },
    {
      name: 'SubmitSuccessfully',
      path: '/submitSuccessfully',
      component: () => import('./src/submitSuccessfully'),
      meta: {
        title: '提交成功',
        openNetwork: true // 公开网络可访问
      }
    },
    {
      name: 'LinkFailure',
      path: '/linkFailure',
      component: () => import('./src/linkFailure'),
      meta: {
        title: '链接无效',
        openNetwork: true // 公开网络可访问
      }
    }
  ]
}
